var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uicons-01-round-medium-trophy 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 22.7773H8",
    stroke: "white",
    strokeWidth: 2.00003,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 22.7773V17.7773",
    stroke: "white",
    strokeWidth: 2.00003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 17.7773C8.82436 17.7773 6.25 15.5387 6.25 12.7773V4.27734C6.25 3.44891 6.92157 2.77734 7.75 2.77734H16.25C17.0784 2.77734 17.75 3.44891 17.75 4.27734V12.7773C17.75 15.5387 15.1756 17.7773 12 17.7773Z",
    stroke: "white",
    strokeWidth: 2.00003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.25098 5.27734H3.50098C2.67255 5.27734 2.00098 5.94891 2.00098 6.77734V8.29774C2.00098 9.38788 2.50894 10.4158 3.3749 11.0779L6.25098 13.2773",
    stroke: "white",
    strokeWidth: 2.00003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.75 5.27734H20.5C21.3284 5.27734 22 5.94891 22 6.77734V8.29774C22 9.38788 21.492 10.4158 20.6261 11.0779L17.75 13.2773",
    stroke: "white",
    strokeWidth: 2.00003
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.ddaafba9da5e8437ad9fc6e052f62fe5.svg";
export { ForwardRef as ReactComponent };